// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__BGXYf","logo":"LoadingScreen_logo__wxIO5"};